// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FormButtonWrap_formButtonWrap__wW4bk {\n  margin-top: 2em;\n}", "",{"version":3,"sources":["webpack://./src/components/form/form-button-wrap/FormButtonWrap.module.scss"],"names":[],"mappings":"AAAA;EACC,eAAA;AACD","sourcesContent":[".formButtonWrap {\n\tmargin-top: 2em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formButtonWrap": "FormButtonWrap_formButtonWrap__wW4bk"
};
export default ___CSS_LOADER_EXPORT___;
